<template>
  <v-col>
    <app-info :order="order" />
    <v-col>
      <h4>Supplier : {{ supplier.firstName }}</h4>
      <h6>Email: {{ supplier.email }}</h6>
    </v-col>
    <table class="table">
      <thead>
        <tr>
          <th class="text-left">
            Item Name
          </th>
          <th class="text-left">
            Bar code
          </th>
          <th class="text-left">
            SKU
          </th>
          <th class="text-left">
            Quantity
          </th>
          <th class="text-left">
            Unit Cost
          </th>
          <th class="text-left">
            Sub Total
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="product in products"
          :key="product.name"
        >
          <td>{{ product.name | capitalize }}</td>
          <td>{{ product.barcode }}</td>
          <td>{{ product.sku }}</td>
          <td>{{ product.qty }}</td>
          <td>{{ product.cost | currency }}</td>
          <td>{{ product.subTotal | currency }}</td>
        </tr>
        <tr>
          <td colspan="7" />
        </tr>
        <tr>
          <td
            colspan="5"
            class="text-right"
          >
            Net Cost
          </td>
          <td class="">
            {{ order.subTotal | currency }}
          </td>
        </tr>
        <tr>
          <td
            colspan="5"
            class="text-right"
          >
            (-) Discount {{ order.discountRate }}%
          </td>
          <td class="">
            {{ order.discountedAmount | currency }}
          </td>
        </tr>
        <tr>
          <td
            colspan="5"
            class="text-right"
          >
            (+) Tax {{ order.taxRate }}%
          </td>
          <td class="">
            {{ order.taxAmount | currency }}
          </td>
        </tr>
        <tr>
          <td
            colspan="5"
            class="text-right"
          >
            Total Payable
          </td>
          <td class="">
            {{ order.totalAmount | currency }}
          </td>
        </tr>
      </tbody>
    </table>
    <terms-conditions />
  </v-col>
</template>

<script>
import Terms from "../common/Terms.vue";
import AppInfo from "../common/ComInfo.vue";
export default {
  components: {
    "terms-conditions": Terms,
    "app-info": AppInfo,
  },
  data() {
    return {
      products: [],
      order: {},
      payment: [],
      supplier: [],
    };
  },
  mounted() {
    if (this.$route.params.id) {
      window.axios.get("/order/" + this.$route.params.id).then((response) => {
        this.$data.order = response.data.order;
        this.$data.products = response.data.order.items;
        this.$data.supplier = response.data.supplier;
        Event.$emit("loadTerms", "purchaseTerms");
      });
    }
  },
};
</script>

<style>
.printBarcode {
  width: 200px;
  height: 25px;
}
</style>
